import React, { useState, useEffect, useMemo, Fragment} from 'react';// , useRef 
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from "formik";
import Dropzone from "react-dropzone";
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles';
import { Input, InputGroups, Select } from "../../../../partials/controls";//, Checkbox
import * as actions from '../../../../store/actions/tenantAction'
import * as manageUserActions from '../../../../store/actions/manageUserAction'
//import SelectChange from './SelectChanges';
import Toast from '../../../../crud/Toast'
import { FormValidationsAdd, FormValidationsEdit } from './FormValidations';
import {DoesDomainExists} from '../../../../crud/tenant.crud'

export default function BasicCustomerInForm(props) {
    const dispatch = useDispatch();

    const { currentUsers}=useSelector((state)=>({
        currentUsers: state.manageUser.users,
    }), shallowEqual);

    const { item, match, saveInformation, industry,
        country, backToTenantList, subscriptions, states,
    } = props;
    const addUrl = '/tenant/add'
    const [toastVisible, setToastVisible] = useState(false);
    const [message, setMessage] = useState('');
    const [toastLevel, setToastLevel] = useState('');
    const classes = useStyles();
    const [dataSource, setItems] = useState(item)
    const fakeUrl = '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'
    const [fileUrl, setFileUrl] = useState(item.logoImage);
    const [countryItems, setcountryItems] = useState(country);
    const [statesItem, setStates] = useState(states);
    useEffect(()=>{
        console.log("id changed", match.params?.id);
        if(match.params?.id){
            dispatch(manageUserActions.getManageUserTenantId({
                params: {
                    "sortField":"",
                    "sortDirection":"",
                    "pageSize":10,
                    "pageNumber":1,
                    "searchText":""
                },
                id: match.params.id}));
        }else{
            dispatch(manageUserActions.resetData());
        }
        dispatch(actions.setActiveStep(0));
    },[dispatch, match.params.id]);
    useEffect(() => {
        setcountryItems(country)
    }, [country])
    useEffect(() => {
        setFileUrl(item.logoImage ? item.logoImage : fakeUrl);
    }, [item.logoImage])
    useEffect(() => {
        setStates(states)
    }, [states])
    const items = useMemo(() => {
        if(item?.domain){
            const editItem = {...item, domain: item.domain.split(".")[0]};            
            return {
                dataSource: editItem,
                setItems
            };
        }else{
            return {
                dataSource: item,
                setItems
            };
        }
    }, [item]);
    const [fileNames, setFileNames] = useState([]);
    const handleDrop = (acceptedFiles, field, values, setValues) => {
        setFileNames(acceptedFiles.map((file) => (file.name)));
        let file = acceptedFiles[0];
        if (file['type'] === 'image/jpeg' || file['type'] === 'image/png') {
            fileFind(file);
        }
    }
    // const [isAddMode, setIsAddMode] = useState(false);
    const fileFind = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            let temp = reader.result;
            setFileUrl(temp.split(',')[1])
        };
        reader.onerror = function (error) {
            alert("Error : " + JSON.stringify(error));
        };
    }
    const leveldata = industry && industry.find(value => value.tenantIndustryID === item.tenantIndustryID);
    const [level, setLevel] = useState(leveldata ? leveldata.tenantIndustryLevels : []);
    const setSubdata = leveldata && leveldata.tenantIndustryLevels && leveldata.tenantIndustryLevels.find(value => value.tenantIndustryLevelsID === item.tenantIndustryLevelID);
    const [subLevel, setSubLevel] = useState(setSubdata && setSubdata['levelSubType']);
    const [subscriptionName, setSubscriptionName] = useState(item.subscriptionType);

    function hendleCountry(e, field, values, setValues) {
        const countryID = parseInt(e.target.value);
        setValues({ ...values, countryID });
        items.setItems({ ...items.dataSource, countryID });
        dispatch(actions.getState(countryID))
        field.onChange(e);
    }

    function hendleIndustry(e, field, values, setValues) {
        const tenantIndustryID = parseInt(e.target.value);
        const leveldatas = industry && industry.find(value => value.tenantIndustryID === tenantIndustryID);
        setLevel(leveldatas ? leveldatas.tenantIndustryLevels ? leveldatas.tenantIndustryLevels : [] : []);
        items.setItems({ ...items.dataSource, tenantIndustryID });
        field.onChange(e);
    }

    function hendleLevels(e, field, values, setValues) {
        const tenantIndustryLevelID = parseInt(e.target.value);
        const leveldataaa = level && level.find(value => value.tenantIndustryLevelsID === tenantIndustryLevelID);
        setSubLevel(leveldataaa ? leveldataaa.levelSubType ? leveldataaa.levelSubType : [] : []);
        items.setItems({ ...items.dataSource, tenantIndustryLevelID });
        field.onChange(e);
    }
    // const [allowAccount, setAllowAccount] = useState(5);
    // const [selfServiceBI, setSelfServiceBI] = useState(false);
    const [showLogo, setShowLogo] = useState(false);
    function hendleSubcription(e, field, value, values, setValues, setFieldValue) {
        const subscriptionID = parseInt(e.target.value)
        setSubscriptionName(value.subscriptionName);
        const domain = value.subscriptionName === 'Premium' ? values.domain : 'xxxx';
        
       // setAllowAccount(value.allowAccount);
        setFieldValue('allowAccount', value.allowAccount);
        setFieldValue('selfServiceBIPurchased', value.selfServiceBI);
        // setSelfServiceBI(value.selfServiceBI);
        
        setShowLogo(value.showLogo);
        if(!value.showLogo){
            setFileUrl(null);
        }else{
            setFileUrl(item?.logoImage||fakeUrl);
        }
        items.setItems({
            ...items.dataSource,
            subscriptionID,
            domain
        });
        field.onChange(e);
    }
    const handleResetLogo = (e)=>{
        setFileUrl(null);
    }
    const handleEmailDomainChanged = async (e,values,setValues)=>{
        var emailDomain = values.emailDomain;
        var superEmail = "email@"+ emailDomain
        setValues({...values,  'superEmail':superEmail,'sponsarEmail':superEmail});
        items.setItems({...items.dataSource, 'superEmail':superEmail,'sponsarEmail':superEmail});
    }
    const handleDomainChanged = async (e, values, setErrors, errors)=>{
        console.log(e, values, setErrors, errors);
        var domainName  = values.domain;
        if(parseInt(values.subscriptionID) === 1)
        {
            setToastVisible(false);
            console.log(parseInt(values.subscriptionID) === 1);
            return;
        }
        var existsResponse = await DoesDomainExists(domainName, values.tenantID||0);        
        console.log(existsResponse);
        if(existsResponse.data.result === true){
            setErrors({...errors, 'domain': 'domain already exists please choose another domain.'});
            setMessage('domain already exists please choose another domain.');
            setToastLevel('danger');
            setToastVisible(true);
        }else{
            setToastVisible(false);
        }   
    }
    // function handlePhoneNumberChange(e, field, values, setErrors){
    //     var value = values[field.name];
    //     // if(!value || value.length !== 10){
    //     //     setErrors({[field.name]: "Phone Number should be exactly 10 digits."});
    //     // }
    //     console.log(value);
    //     field.onBlur(e);
    // }
    function handleAllowAccountChange(e, field, values, setErrors){ 
            console.log(currentUsers, values.allowAccount,match.params?.id);
            if(match.params?.id && currentUsers && values.allowAccount < currentUsers.totalItems){
                setErrors({allowAccount: 'Please delete the Users from ‘Manage Users Page’ to reflect the number of Users you want to reduce to'});                
            }
        field.onBlur(e);
    }
    useEffect(()=>{
        var subscription = subscriptions.items?.find(s=>s.subscriptionID === parseInt(item.subscriptionID));
        if(subscription){           
            setShowLogo(subscription.showLogo);
            if(!subscription.showLogo){
                setFileUrl(null);
            }
        }       
    },[item.subscriptionID, subscriptions]);

    function hendlePurchased(e, field, values, setValues) {
        const selfServiceBIPurchased = Boolean(e.target.value);
        // setSelfServiceBI(prev=>!prev);
        items.setItems({ ...items.dataSource, selfServiceBIPurchased });
        field.onChange(e);
    }

    function hendleImages(e, field, values, setValues) {
        const file = e.target.files[0]
        fileFind(file)
        setValues({ ...items.dataSource, fileUrl });
    }

    const onSubmitHeandle = async (values,{setErrors}) =>  {
        console.log("in onSubmitHeandle", values, currentUsers);
        if(parseInt(values.subscriptionID) !== 1){
            var domainName  = values.domain;
            var existsResponse = await DoesDomainExists(domainName, values.tenantID ||0);        
            console.log(existsResponse);
            if( existsResponse.data.result === true){
                setErrors({'domain': 'domain already exists please choose another domain.'});
                setMessage('domain already exists please choose another domain.');
                setToastLevel('danger');
                setToastVisible(true);   
                return;            
            }
        }
        if(match.params?.id && currentUsers && values.allowAccount < currentUsers.totalItems){           
            setErrors({allowAccount: 'Please delete the Users from ‘Manage Users Page’ to reflect the number of Users you want to reduce to'});
            // setMessage('Please delete the Users from ‘Manage Users Page’ to reflect the number of Users you want to reduce to');
            // setToastLevel('danger');
            // setToastVisible(true);
        }else if (!values.countryID) {           
            setErrors({countryID: 'Please select country...'});
            setMessage('Please select country...');
            setToastLevel('danger');
            setToastVisible(true);
        } else if (!values.tenantIndustryID) {           
            setErrors({tenantIndustryID: 'Please select Tenant Industry...'});
            setMessage('Please select Tenant Industry...');
            setToastLevel('danger');
            setToastVisible(true);
        } else if (!values.tenantIndustryLevelID) {           
            setErrors({tenantIndustryLevelID: 'Please select Tenant Industry Level...'});
            setMessage('Please select Tenant Industry Level...');
            setToastLevel('danger');
            setToastVisible(true);
        } else {
            if(fileUrl === fakeUrl){                
                setFileUrl(null);
                saveInformation(values);
            }else{
                saveInformation(values, fileUrl);
            }
        }
        // // Commented to make it non required field while submitting
        // else if(!values.levelSubTypeID) {
        //     setMessage('Please select Level Type...');
        //     setToastVisible(true)
        // }
    };

    return (
        <>
            {items.dataSource && <Formik
                enableReinitialize
                initialValues={items.dataSource}
                validationSchema={match.url === addUrl ? FormValidationsAdd : FormValidationsEdit}
                onSubmit={async (values, actions) => {
                    console.log('in formik onSubmit',values);
                    await onSubmitHeandle( values, actions);
                }}
            >
                {({ handleSubmit, values, errors, touched, setValues, setFieldValue, setErrors }) => (
                    <Form>
                        <div className={classes.container}>
                            {showLogo && <div className={classes.commonContainer}>
                                <div className={classes.basicLable}>
                                    <h6 style={{ margin: 0 }}>Upload Logo*:</h6>
                                </div>
                                <div className={classes.profileContainer}>
                                    <div className={classes.profileImage}>
                                        <img className={classes.img} src={"data:image/jpeg;base64," + (fileUrl||fakeUrl)} alt="Profile Pic" />
                                    </div>
                                    <Button size="small" color="primary" style={{alignItems: 'flex-end'}} onClick={handleResetLogo}>Reset Logo</Button>
                                </div>
                                <div className={classes.uploadContainer}>
                                    <Field name="logoImage">
                                        {({ field }) => (
                                            <Dropzone onDrop={e => handleDrop(e, field, values, setValues)}>
                                                {({ getRootProps, getInputProps }) => (
                                                    <div {...getRootProps({ className: "dropzone" })}>
                                                        <>
                                                            <input {...getInputProps()} onBlur={(e) => hendleImages(e, field, values, setValues)} type="file" />
                                                        </>
                                                        <p>Drag'n'drop files, or click to select files</p>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        )}
                                    </Field>
                                </div>
                            </div>}
                            <div className="row">
                                <div className="col-sm-4">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Tenant Name*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="tenantName"
                                                component={Input}
                                                placeholder="Tenant Name"
                                                label="tenantName"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className={classes.commonContainer}>
                                        <div >
                                            <h6 style={{ marginBottom: subscriptions?.items?.find(s=>s.subscriptionID === parseInt(values.subscriptionID))?.customDomain?16:0 }}>Domain:</h6>
                                        </div>
                                        <div className={classes.domainContainer}>
                                            {subscriptions.items && subscriptions.items.map((value) => (                                                
                                                <Fragment key={`domain${value.subscriptionID}`}>
                                                    {value.subscriptionID === parseInt(values.subscriptionID) ? 
                                                        <>
                                                            {value.customDomain ? 
                                                                <div> 
                                                                    <Field name="domain"
                                                                        component={InputGroups}
                                                                        groupSuffix={process.env.REACT_APP_TENANT_DOMAIN_SUFFIX}
                                                                        placeholder="Domain"
                                                                        label="domain"
                                                                        onBlur = {e=> handleDomainChanged(e, values, setErrors, errors)}
                                                                        className={"form-control"}                                                                       
                                                                        disabled={match.url !== addUrl}
                                                                            />
                                                                    <ErrorMessage name="domain" component="div" className="invalid-feedback" />
                                                                </div>
                                                            : <>
                                                                <Field name="domain">
                                                                    {({ field }) => (
                                                                        <>
                                                                            <input {...field}
                                                                                className={"form-control"}
                                                                                type="text"
                                                                                // readOnly
                                                                                disabled
                                                                                value="xxxx"
                                                                            />
                                                                        </>
                                                                    )}
                                                                </Field>
                                                            </>}
                                                        </> 
                                                    : null}
                                                </Fragment>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable} style={{minWidth: '195px'}}>
                                            <h6 style={{ margin: 0 }}>Number of account allowed*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field name="allowAccount">
                                                
                                            {({field})=>(
                                                <input 
                                                    {...field}
                                                    className={"form-control" + (errors.allowAccount && touched.allowAccount ? ' is-invalid' : ' is-valid')}
                                                    // component={Input}
                                                    placeholder="allowAccount"
                                                    label="allowAccount"
                                                    // value = {allowAccount}
                                                    onBlur = {e=> handleAllowAccountChange(e, field, values, setErrors)}
                                                />
                                                )}
                                            </Field><ErrorMessage name="allowAccount" component="div" className="invalid-feedback" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}> </h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <div style={{ padding: 10 }}>
                                                <div className="row">
                                                    {subscriptions.items && subscriptions.items.map((value) => (
                                                        <div className="col-sm-4" key={value.subscriptionID}>
                                                            <Field name="subscriptionID" >
                                                                {({ field }) => (
                                                                    <>
                                                                        <input {...field}
                                                                            className={"mr-2 leading-tight" + (errors.subscriptionID && touched.subscriptionID ? ' is-invalid' : ' is-valid')}
                                                                            type="radio"
                                                                            value={value.subscriptionID}
                                                                            onChange={e => hendleSubcription(e, field, value, values, setValues, setFieldValue)}
                                                                            checked={parseInt(field.value) === value.subscriptionID}
                                                                        />
                                                                        <span className="text-sm">{value.subscriptionName}</span>
                                                                    </>
                                                                )}
                                                            </Field>
                                                            <ErrorMessage name="subscriptionID" component="div" className="invalid-feedback" />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Email Domain Name*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="emailDomain"
                                                component={Input}
                                                placeholder="Email Domain Name"
                                                label="Email Domain Name"  
                                                onBlur = {e=>handleEmailDomainChanged(e,values,setValues)}
                                                disabled={match.url !== addUrl} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Super Admin*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <Field
                                                        name="superFirstName"
                                                        component={Input}
                                                        placeholder="First Name"
                                                        label="First Name"
                                                        disabled={match.url !== addUrl}
                                                    />
                                                </div>
                                                <div className="col-sm-3">
                                                    <Field
                                                        name="superLastName"
                                                        component={Input}
                                                        placeholder="Last Name"
                                                        label="Last Name"
                                                        disabled={match.url !== addUrl}
                                                    />
                                                </div>
                                                <div className="col-sm-2">
                                                    <Field name="superPhoneNo"
                                                        component={Input}
                                                        placeholder="1234567890"
                                                        label="Phone No."
                                                        type="tel"
                                                        disabled={match.url !== addUrl}     
                                                        />                                         
                                                </div>
                                                <div className="col-sm-4">
                                                    <Field
                                                        name="superEmail"
                                                        component={Input}
                                                        placeholder={values.emailDomain?"email@"+values.emailDomain:'Email'}
                                                        label="Email"
                                                        disabled={match.url !== addUrl}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Sponsor*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <Field
                                                        name="sponsarFirstName"
                                                        component={Input}
                                                        placeholder="First Name"
                                                        label="First Name"
                                                        disabled={match.url !== addUrl}
                                                    />
                                                </div>
                                                <div className="col-sm-3">
                                                    <Field
                                                        name="sponsarLastName"
                                                        component={Input}
                                                        placeholder="Last Name"
                                                        label="Last Name"
                                                        disabled={match.url !== addUrl}
                                                    />
                                                </div>
                                                <div className="col-sm-2">
                                                    <Field name="sponsarPhoneNo"
                                                        component={Input}
                                                        placeholder="123456789"
                                                        label="Phone No."
                                                        type="tel"
                                                        disabled={match.url !== addUrl}                                                                
                                                        />   
                                                </div>
                                                <div className="col-sm-4">
                                                    <Field
                                                        name="sponsarEmail"
                                                        component={Input}
                                                        placeholder={values.emailDomain?"email@"+values.emailDomain:'Email'}
                                                        label="Email"
                                                        disabled={match.url !== addUrl}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Tenant Industry:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field name="tenantIndustryID">
                                                {({ field }) => (
                                                    <select
                                                        {...field}
                                                        className={'form-control' + (errors.tenantIndustryID && touched.tenantIndustryID ? ' is-invalid' : ' is-valid')}
                                                        onChange={e => hendleIndustry(e, field, values, setValues)}
                                                    >
                                                        <option value=""></option>
                                                        {industry && industry.map((items) => (
                                                            <option 
                                                                key={items.tenantIndustryID} 
                                                                value={items.tenantIndustryID}
                                                            >
                                                                {items.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                            </Field>
                                            <ErrorMessage name="tenantIndustryID" component="div" className="invalid-feedback" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Tenant/Entity type*</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Field name="tenantIndustryLevelID">
                                                        {({ field }) => (
                                                            <select
                                                                {...field}
                                                                className={'form-control' + (errors.tenantIndustryLevelID && touched.tenantIndustryLevelID ? ' is-invalid' : ' is-valid')}
                                                                onChange={e => hendleLevels(e, field, values, setValues)}
                                                            >
                                                                <option value=""></option>
                                                                {level && level.map((items) => (
                                                                    <option key={items.tenantIndustryLevelsID} value={items.tenantIndustryLevelsID}>
                                                                        {items.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        )}
                                                    </Field>
                                                    <ErrorMessage name="tenantIndustryLevelID" component="div" className="invalid-feedback" />
                                                </div>
                                                <div className="col-sm-6">
                                                    <Select name="levelSubTypeID" label="subtype">
                                                        <option value="null">Please Select</option>
                                                        {subLevel && subLevel.map((item) => (
                                                            <option key={item.name} value={item.levelSubTypeID}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.head}>
                                <h5>Customer Info</h5>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Business Legal Name*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="businessName"
                                                component={Input}
                                                placeholder="Business Name"
                                                label="Business Name"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Billing Email*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="billingEmail"
                                                component={Input}
                                                placeholder="Billing Email"
                                                label="Billing Email"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Address 1*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="address1"
                                                component={Input}
                                                placeholder="Address 1"
                                                label="Address 1"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Address 2:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="address2"
                                                component={Input}
                                                placeholder="Address 2"
                                                label="Address 2"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Country*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field name="countryID">
                                                {({ field }) => (
                                                    <select
                                                        {...field}
                                                        className={'form-control' + (errors.countryID && touched.countryID ? ' is-invalid' : ' is-valid')}
                                                        onChange={e => hendleCountry(e, field, values, setValues)}
                                                    >
                                                        <option value=""></option>
                                                        {countryItems && countryItems.map(items =>
                                                            <option key={items.countryID} value={items.countryID}>
                                                                {items.countryName}
                                                            </option>
                                                        )}
                                                    </select>
                                                )}
                                            </Field>
                                            <ErrorMessage name="countryID" component="div" className="invalid-feedback" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>State*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            {statesItem && statesItem.length > 0 ?
                                                <>
                                                    <Field
                                                        name="stateID"
                                                        as="select"
                                                        className={'form-control' + (errors.stateID && touched.stateID ? ' is-invalid' : ' is-valid')}
                                                    >
                                                        <option value=""></option>
                                                        {statesItem.map((items) => (
                                                            <option key={items.stateID} value={items.stateID}>
                                                                {items.stateName}
                                                            </option>
                                                        ))}
                                                    </Field>
                                                    <ErrorMessage name="stateID" component="div" className="invalid-feedback" />
                                                </>
                                                :
                                                <Field
                                                    name="otherState"
                                                    component={Input}
                                                    placeholder="Other State"
                                                    label="Other State"
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>City*:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="city"
                                                component={Input}
                                                placeholder="city"
                                                label="city"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>ZipCode: </h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="zipCode"
                                                component={Input}
                                                placeholder="ZipCode"
                                                label="Zip Code"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable}>
                                            <h6 style={{ margin: 0 }}>Tax ID:</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <Field
                                                name="taxID"
                                                component={Input}
                                                placeholder="taxID"
                                                label="taxID"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className={classes.commonContainer}>
                                        <div className={classes.basicLable} style={{minWidth:'165px'}}>
                                            <h6 style={{ margin: 0 }}>Self Service BI required?*</h6>
                                        </div>
                                        <div className={classes.inputContainer}>
                                            <div style={{ padding: 10 }}>
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <Field name="selfServiceBIPurchased">
                                                            {({ field }) => (
                                                                <>
                                                                    <input {...field}
                                                                        className={"mr-2 leading-tight" + (errors.selfServiceBIPurchased && touched.selfServiceBIPurchased ? ' is-invalid' : ' is-valid')}
                                                                        type="radio"
                                                                        value='true'
                                                                        onChange={e => hendlePurchased(e, field, values, setValues)}
                                                                        checked={field.value === true || field.value === 'true'}//{selfServiceBI === true}//
                                                                    />
                                                                    <span className="text-sm">Yes</span>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <Field name="selfServiceBIPurchased">
                                                            {({ field }) => (
                                                                <>
                                                                    <input {...field}
                                                                        className={"mr-2 leading-tight" + (errors.selfServiceBIPurchased && touched.selfServiceBIPurchased ? ' is-invalid' : ' is-valid')}
                                                                        type="radio"
                                                                        value='false'
                                                                        onChange={e => hendlePurchased(e, field, values, setValues)}
                                                                        checked={field.value === false || field.value === 'false'}//{selfServiceBI === false}//
                                                                    />
                                                                    <span className="text-sm">No</span>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div style={{ padding: '10px 0', display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={backToTenantList}
                                        >
                                            Back
                                        </Button>
                                        &nbsp;&nbsp;
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={async(e) =>{
                                                //await handleDomainChanged(e,values, setErrors, errors);
                                                console.log("submit button onclick");
                                               // handleSubmit();
                                            }}
                                            disabled={match.params.id ? false : !values.tenantID ? false : true}
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )
                }
            </Formik>}
            <Toast
                level={toastLevel}
                message={message}
                visible={toastVisible}
            />
        </>
    )
}

const useStyles = makeStyles({
    container: {
        padding: 10,
        borderTop: 'solid 1px #dddddd'
    },
    list: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '8px 0px'
    },
    commonContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '10px 0px',
        '@media (max-width:1140px)': { 
            display: 'block',
            overflow: 'hidden'
        }
    },
    basicLable: {
        minWidth: 155,
        '@media (max-width:1540px)': { 
            minWidth: 100,
        },
        '@media (max-width:1140px)': { 
            minWidth: "100%",
            paddingBottom: 10
        }
    },
    profileContainer: {
        minWidth: 240,
        display: 'flex',
        '@media (max-width:1140px)': { 
            float: 'left',
            minWidth: 140,
        }
    },
    profileImage: {
        width: 120,
        height: 120
    },
    img: {
        maxWidth: '100%',
        maxHeight: '100%'
    },
    uploadContainer: {
        width: 'calc(100% - 435px)',
        '@media (max-width:1140px)': { 
            width: 'calc(100% - 140px)',
            float: 'left'
        }
    },
    inputContainer: {
        width: 'calc(100% - 155px)',
        '@media (max-width:1540px)': { 
            width: 'calc(100% - 100px)',
        },
        '@media (max-width:1140px)': { 
            width: '100%',
        }
    },
    domainContainer: {
        width: 'calc(100% - 55px)',
        '@media (max-width:1540px)': { 
            width: 'calc(100% - 55px)',
        },
        '@media (max-width:1140px)': { 
            width: '100%',
        }
    },
    head: {
        padding: '10px 0px'
    }
});